export class messageConstant {
  public static readonly OK = 'OK';
  public static readonly CANCEL = 'CANCEL';
  public static readonly NEXT = 'NEXT';
  public static readonly BACK = 'BACK';
  public static readonly SKIP = 'SKIP';
  public static readonly ERROR = 'ข้อมูลไม่ถูกต้องกรุณาทำรายการใหม่อีกครั้ง';
  public static readonly MAIN_MENU = 'MAIN MENU';
  public static readonly BUY_MORE = 'BUY MORE';
  public static readonly PAY_NOW = 'PAY NOW';
  public static readonly ADD_TO_CART = 'ADD TO CART';
  public static readonly BUY_NOW = 'BUY NOW';

  public static readonly SUCCESS_PRODUCT_ADD_TO_CART =
    'เพิ่มสินค้าไปยังตะกร้าสำเร็จ';
  public static readonly ERROR_PRODUCT_ADD_TO_CART =
    'ไม่สามารถเพิ่มสินค้าไปยังตะกร้าได้';

  public static readonly SUCCESS_PAYMENT_LS_CONTRACT_NUMBER = 'ข้อมูลครบถ้วน';
  public static readonly ERROR_PAYMENT_CREDIT_CARD_BANK_NOT_MATCH =
    'เลขที่บัตรเครดิตไม่ตรงกับธนาคารที่เลือก';
  public static readonly ERROR_CUSTOMER_PHONE_NUMBER =
    'กรุณากรอกเบอร์ให้ถูกต้อง';
  public static readonly ERROR_CUSTOMER_DATA_NOT_FOUND =
    'ไม่พบข้อมูลลูกค้ากรุณาเสียบบัตรประชาชนเพื่อยืนยันตัวตน';
  public static readonly ERROR_CUSTOMER_DATA_NOT_FOUND_IS_NOT_ID_CARD =
    'ไม่พบข้อมูลลูกค้า';
  public static readonly ERROR_CUSTOMER_PHONE_NUMBER_TERMINATE =
    'ไม่สามารถดำเนินการต่อด้วยหมายเลขนี้ได้';
  public static readonly ERROR_CUSTOMER_LIST_NUMBER_ERROR =
    'ไม่พบหมายเลขที่สามารถทำรายการได้';
  public static readonly ERROR_CUSTOMER_ID_CARD_HAVE_PHNOE_NUMBER_TERMINATE_READ_CARD =
    'ไม่พบหมายเลขที่สามารถทำรายการได้ต้องการดำเนินการต่อด้วยหมายเลขอื่นหรือไม่';
  public static readonly ERROR_CUSTOMER_CAN_NOT_READ_CARD =
    'ไม่สามารถอ่านบัตรประชาชนได้ กรุณาเสียบบัตรใหม่อีกครั้ง';
  public static readonly ERROR_CUSTOMER_FORMAT_INPUT =
    '*กรุณากรอกรูปแบบให้ถูกต้อง';
  public static readonly ERROR_CUSTOMER_FORMAT_INPUT_ALIEN =
    '*กรุณากรอกเลขบัตรประจำตัวคนต่างด้าวให้ถูกต้อง';
  public static readonly ERROR_CUSTOMER_FORMAT_INPUT_ID_CARD =
    '*กรุณากรอกเลขบัตรประชาชนให้ถูกต้อง';
  public static readonly ERROR_CUSTOMER_FORMAT_INPUT_PASSPORT =
    '*กรุณากรอกเลขบัตรหนังสือเดินทางให้ถูกต้อง';
  public static readonly ERROR_CUSTOMER_FORMAT_INPUT_PHONE_NUMBER =
    '*กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง';

  public static readonly ERROR_CART_LIST_LIMIT = 'มีสินค้าอยู่ในตะกร้าอยู่แล้ว';

  public static readonly RESUME_TOKEN_MESSAGE =
    'Session ใกล้หมดอายุ กด ตกลง เพื่อดำเนินการต่อ';

  public static readonly STOCK_TUMBOL = 'TUMBOL_TH';
  public static readonly STOCK_AMPHUR = 'AMPHUR_TH';
  public static readonly STOCK_PROVINCE = 'PROVINCE';
  public static readonly STOCK_NAVIGATE_ERROR =
    'ไม่สามารถเข้าใช้งานเมนู Stock ได้';
}
